import * as actionTypes from "./actionTypes";

export function savePgaOnGivenHtsCode(payload) {
  return {
    type: actionTypes.SAVE_PGA_ON_HTS,
    payload,
  };
}
